import ExamsRoleByStudentDataStore from '../../datastores/ExamsRoleByStudentDataStore';

const urlExamClassFake =
  'https://class.utp.edu.pe/student/courses/663e8adf-5443-55f1-a7af-58fd55db18ba/section/e80f9d75-34ae-5fde-8bcb-e42361839d5a/listEvaluation';

const dataExamRol: any = {
  examsFinals: [
    {
      id: 1,
      date: 1764633600000, // 'Lunes, 1 de diciembre',
      courses: [
        {
          id: '0132201',
          name: 'Introducción a la vida universitaria: ingeniería electrónica, biomédica, mecatrónica y eléctrica',
          start: '20:15',
          end: '21:45',
          urlExamClass: urlExamClassFake,
          location: {
            classroom: 'B0101',
            campus: 'C_LNORTE'
          },
          about: '148',
          modality: 'P',
          isDisabled: false
        },
        {
          id: '0132202',
          name: 'Introducción a la vida universitaria: ingeniería mecatrónica y eléctrica',
          start: '20:15',
          end: '21:45',
          urlExamClass: urlExamClassFake,
          location: null,
          about: '148',
          modality: 'R',
          isDisabled: false
        }
      ]
    }
  ],
  examsLagging: [
    {
      id: 1,
      date: 1765411200000, // 'Miércoles, 10 de diciembre',
      courses: [
        {
          id: '0132203',
          name: 'Estadística descriptiva y probado',
          start: '08:00',
          end: '10:00',
          urlExamClass: urlExamClassFake,
          location: {
            classroom: 'B0201',
            campus: 'C_LNORTE'
          },
          about: '145',
          modality: 'P',
          isDisabled: false
        }
      ]
    }
  ],
  examsReturn: [
    {
      id: 1,
      date: 1765756800000, // 'Domingo, 14 de diciembre',
      courses: [
        {
          id: '0132204',
          name: 'Curso de prueba 2',
          start: '08:00',
          end: '10:00',
          urlExamClass: urlExamClassFake,
          location: {
            classroom: 'B0301',
            campus: 'C_LNORTE'
          },
          about: '123',
          modality: 'P',
          isDisabled: false
        }
      ]
    }
  ]
};

export default class ExamsRoleByStudentDataStoreMock
  implements ExamsRoleByStudentDataStore
{
  async getExamsRoleByStudent() {
    return dataExamRol;
  }
}
